<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "fileEdit",
      key: "id",
      url: {
        get: "/admin/system/resourceDownload",
        add: "/admin/system/resourceDownload",
        edit: "/admin/system/resourceDownload",
      },
      id: "",
      items: [
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
        },
        {
          label: "名称",
          name: "name",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "状态",
          name: "delStatus",
          value: 1,
          type: "select",
          rules: [{ required: true }],
          dropList: [
            {
              name: "展示",
              value: 1,
            },
            {
              name: "不展示",
              value: 2,
            },
          ],
          width: "400px",
        },
        {
          label: "文件",
          name: "path",
          value: "",
          type: "documentsAll",
          desc: "",
          rules: [{ required: true, trigger: "blur" }],
          handleRemove: this.handleRemove,
        },
         {
          label: "备注",
          name: "content",
          value: "",
          type: "input",
          width: "400px",
        },
      ],
      forms: {
        delStatus: 1,
      },
    };
  },
  props: ["searchFun", "actions", "kvId"],
  created() {
    if (this.actions == "edit") {
      this.kv = this.kvId;
      this.initData();
    }
  },
  methods: {
    handleSubmit() {
      let q = this.forms;
      if (!this.forms.name) {
        $utils.toast.error("名称不能为空！");
        return;
      }
      if (!this.forms.delStatus) {
        $utils.toast.error("请选择状态！");
        return;
      }
      if (!this.forms.path) {
        $utils.toast.error("请上传文件！");
        return;
      }
      this.sloading = true;
      $utils.api
        .load(
          `/admin/system/resourceDownload`,
          q,
          this.actions == "edit" ? "PUT" : "POST"
        )
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success("保存成功");
            this.$emit("searchFun", true);
            this.$Modal.remove();
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
  },
};
</script>
